import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

export const renderAuthDialog = (data?) => openPopupHelper({ popupName: popupNames.AUTH_DIALOG, data });
